import colors from 'config/config/colors';

import { isMobile } from 'react-device-detect';

const BackNextButton = {
	justifyContent: 'between', // center, between, end, start or evenly
	icon: {
		show: true,
		variant: 'cercleArrow', // simpleArrow or cercleArrow
		color: {
			icon: colors.primary,
			bg: colors.white,
		},
		size: {
			height: 20,
			width: 20,
		},
		margin: 12,
	},
	margins: {
		top: isMobile ? '20px' : '30px',
		bottom: isMobile ? '20px' : '50px',
		between: isMobile ? '10px' : '30px',
	},
	defaultText: {
		back: 'Anterior',
		next: 'Siguiente',
		contract: 'Contratar',
	},
};

export default BackNextButton;
